import { forwardRef, ReactElement, useEffect, useState } from 'react';
import styled, { Keyframes, keyframes, useTheme } from 'styled-components';

const transitions = {
  enter: keyframes`
    from {
      opacity: 0;
      transform: scale(0.5);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  `,
  exit: keyframes`
    from {
      opacity: 1;
      transform: scale(1);
    }
    to {
      opacity: 0;
      transform: scale(0.5);
    }
  `,
};

const TransitionStyled = styled.div<{ transition: Keyframes; duration: number }>`
  animation-fill-mode: forwards;
  animation-duration: ${(p) => p.duration}ms;
  animation-name: ${(p) => p.transition};
`;

export type JourneyEditPreviewOpenCloseTransitionProps = {
  in: boolean;
  children: ReactElement;
  onEnter?: () => void; // automatically provided by mui-base's <ModalUnstyled>
  onExited?: () => void; // automatically provided by mui-base's <ModalUnstyled>
};

export const JourneyEditPreviewOpenCloseTransition = forwardRef<
  // Focus trap won't work without forwarding
  HTMLDivElement,
  JourneyEditPreviewOpenCloseTransitionProps
>((props, ref) => {
  const { in: isOpen, onEnter, onExited, children } = props;
  const [isExiting, setIsExiting] = useState(false);
  const transitionDuration = useTheme().transitions.normal;
  console.log('transitionDuration is: ', transitionDuration);

  useEffect(() => {
    if (isOpen) {
      onEnter?.();
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen && !isExiting) {
      setIsExiting(true);
      setTimeout(() => onExited?.(), transitionDuration ?? 0);
    }
  }, [isOpen, isExiting]);

  useEffect(() => {
    if (isOpen && isExiting) {
      setIsExiting(false);
    }
  }, [isOpen, isExiting]);

  const transition = isOpen && !isExiting ? transitions.enter : transitions.exit;

  return (
    <TransitionStyled ref={ref} tabIndex={-1} transition={transition} duration={transitionDuration}>
      {children}
    </TransitionStyled>
  );
});

JourneyEditPreviewOpenCloseTransition.displayName = 'JourneyEditPreviewOpenCloseTransition';
